"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPopup = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var IconButton_1 = require("./IconButton");
var Text_1 = require("./Text");
var colors_1 = require("../colors");
var icons_1 = require("../icons");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    button: {
        alignItems: 'center',
        backgroundColor: (0, colors_1.getColor)('GRAY_BG'),
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        gap: '18px',
        height: '56px',
        padding: '16px 20px',
        width: '100%',
    },
    buttonContainer: {
        marginBottom: '4px',
    },
    closeIcon: {
        padding: 0,
    },
    closeIconContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '13px 13px 8px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        padding: "0 !important",
        width: '280px',
    },
    externalProvidersTextContainer: {
        padding: '21px 16px 11px',
    },
    textWeight: {
        fontWeight: 300,
    },
    galleryTextContainer: {
        padding: '0 16px 16px',
    },
}); });
var AvatarPopup = function (_a) {
    var configuration = _a.configuration, onClick = _a.onClick, onClose = _a.onClose, open = _a.open;
    var classes = useStyles();
    var isAnySocialShown = [
        configuration.showFacebook,
        configuration.showInstagram,
        configuration.showGoogle,
        configuration.showYahoo,
    ].some(function (el) { return !!el; });
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": 'import-avatar-popup', onClose: onClose, open: open },
        react_1.default.createElement(core_1.DialogContent, { classes: { root: classes.content } },
            react_1.default.createElement("div", { className: classes.closeIconContainer },
                react_1.default.createElement(IconButton_1.IconButton, { className: classes.closeIcon, icon: react_1.default.createElement(icons_1.Icon.Outline.Exit, null), onClick: onClose, stylesProps: {
                        backgroundColor: 'WHITE_100',
                        color: 'BLACK_100',
                        size: 24,
                        withShadow: false,
                    } })),
            configuration.showGallery ? (react_1.default.createElement(react_1.default.Fragment, null,
                configuration.textGallery ? (react_1.default.createElement("div", { className: classes.galleryTextContainer },
                    react_1.default.createElement(Text_1.Text, { className: classes.textWeight, color: 'BLACK_20', variant: 'label' }, configuration.textGallery))) : null,
                react_1.default.createElement("div", { className: classes.buttonContainer },
                    react_1.default.createElement("button", { className: classes.button, onClick: function () { return onClick('gallery'); }, type: 'button' },
                        react_1.default.createElement(icons_1.Icon.Outline.Gallery, { color: 'BLACK_60' }),
                        react_1.default.createElement(Text_1.Text, { color: 'BLACK_60', variant: "bodyMedium" }, "Gallery"))))) : null,
            isAnySocialShown && configuration.textSocial ? (react_1.default.createElement("div", { className: classes.externalProvidersTextContainer },
                react_1.default.createElement(Text_1.Text, { className: classes.textWeight, color: 'BLACK_20', variant: 'label' }, configuration.textSocial))) : null,
            configuration.showFacebook ? (react_1.default.createElement("div", { className: classes.buttonContainer },
                react_1.default.createElement("button", { className: classes.button, onClick: function () { return onClick('facebook'); }, type: 'button' },
                    react_1.default.createElement(icons_1.Icon.Creative.Facebook, null),
                    react_1.default.createElement(Text_1.Text, { color: 'BLACK_60', variant: "bodyMedium" }, "Facebook")))) : null,
            configuration.showInstagram ? (react_1.default.createElement("div", { className: classes.buttonContainer },
                react_1.default.createElement("button", { className: classes.button, onClick: function () { return onClick('instagram'); }, type: 'button' },
                    react_1.default.createElement(icons_1.Icon.Creative.Instagram, null),
                    react_1.default.createElement(Text_1.Text, { color: 'BLACK_60', variant: "bodyMedium" }, "Instagram")))) : null,
            configuration.showGoogle ? (react_1.default.createElement("div", { className: classes.buttonContainer },
                react_1.default.createElement("button", { className: classes.button, onClick: function () { return onClick('google'); }, type: 'button' },
                    react_1.default.createElement(icons_1.Icon.Creative.Google, null),
                    react_1.default.createElement(Text_1.Text, { color: 'BLACK_60', variant: "bodyMedium" }, "Google")))) : null,
            configuration.showYahoo ? (react_1.default.createElement("div", { className: classes.buttonContainer },
                react_1.default.createElement("button", { className: classes.button, onClick: function () { return onClick('yahoo'); }, type: 'button' },
                    react_1.default.createElement(icons_1.Icon.Creative.Yahoo, null),
                    react_1.default.createElement(Text_1.Text, { color: 'BLACK_60', variant: "bodyMedium" }, "Yahoo")))) : null)));
};
exports.AvatarPopup = AvatarPopup;
